import "../pages/HealthCheckPage.css";
import React, {memo, useMemo} from "react";
import {AgGridReact} from 'ag-grid-react';
import {
    ColDef,
    ColGroupDef,
    GridOptions,
    themeQuartz,
    ValueGetterParams,
    ModuleRegistry,
    RowStyleModule,
    CellStyleModule,
    TextFilterModule,
    NumberFilterModule,
    CustomFilterModule,
    ClientSideRowModelModule,
} from 'ag-grid-community';
import {
    SetFilterModule,
    MultiFilterModule,
} from 'ag-grid-enterprise';

import {cellFormatter, computeColumnSizes, DocumentLinkComponent, ProductLinkComponent} from "shared/components/table";
import {
    BrokenUrlDoc,
    EmptyProdRow,
    ManufacturerIntersection,
    SkippedProdsRow,
    UnexpectedKeywordRow
} from "features/healthcheck/types";

ModuleRegistry.registerModules([
    RowStyleModule,
    CellStyleModule,
    TextFilterModule,
    NumberFilterModule,
    CustomFilterModule,
    ClientSideRowModelModule,
    SetFilterModule,
    MultiFilterModule,
]);

const UncoloredTable = ({result, columns}: {result: ManufacturerIntersection[]|UnexpectedKeywordRow[]|EmptyProdRow[]|SkippedProdsRow[]|BrokenUrlDoc[], columns: string[]}) => {
    const columnSizes = useMemo(() => computeColumnSizes(columns, result), [result, columns]);

    const colDefs: (ColDef<any, any> | ColGroupDef<any>)[] = useMemo(() => { return [
        {
            headerName: "Row",
            valueGetter: (p: ValueGetterParams) => ((p.node?.rowIndex ?? 0) + 1) + ', ' + p.data.URL,
            cellRenderer: ProductLinkComponent,
            filter: false,
            comparator: (valueA, valueB) => valueA.split(', ')[0] - valueB.split(', ')[0],
            flex: columnSizes['Row']
        },
        ...columns
            .filter(c => !c.includes('Sheet') && c !== "imageFile")
            .map(c => {
            return {
                field: c,
                valueFormatter: cellFormatter,
                filter: true,
                flex: columnSizes[c],
            }
        }),
        ...columns
            .filter(c => c.includes('Sheet') || c === "imageFile")
            .map(c => {
            return {
                field: c,
                valueFormatter: cellFormatter,
                cellRenderer: DocumentLinkComponent,
                filter: true,
                flex: columnSizes[c],
            }
        }),
    ]}, [columns, columnSizes]);

    const tableTheme = themeQuartz.withParams({
        spacing: 3,
        foregroundColor: 'white',
        backgroundColor: '#27374D',
        headerBackgroundColor: '#354A5F',
        rowHoverColor: '#496F87',
    });

    const gridOptions: GridOptions =  {
        defaultColDef: {
            flex: 1,
            sortable: true,
            filter: true,
        },
        enableFillHandle: true,
        enableCellTextSelection: true,
        suppressHorizontalScroll: false,
    };

    return (
        <div className="excel-table-container scrollable" style={{width: columnSizes['generalLength'] * 8, minWidth: '100%'}}> {/**/}
            <AgGridReact
                rowData={result}
                columnDefs={colDefs}
                gridOptions={gridOptions}
                theme={tableTheme}
            />
        </div>
    );
}

export default memo(UncoloredTable);